const SlipUp = () => (
    <section id="slip-up">
        <div className="container-fluid pt-4 pb-4 text-center">
            <div className="row align-items-center justify-content-center">
                <div className="col-md-8 col-11">
                    <h3 className="mb-5"><b>Most People Slip Up Right Here.</b></h3>
                    <h5 className="fw-light mb-4">They feel a shift after one bottle… a little less brain fog… a little more energy… <br />…and then they stop.</h5>
                    <h5 className="fw-light mb-4">Right before the real transformation begins.</h5>
                    <h5 className="fw-light mb-4">GlucoGen<sup>17</sup> isn’t a magic pill.</h5>
                    <h5 className="fw-light">It’s a metabolic reset, and the body needs time to respond. Those first few weeks? That’s just your system waking up.</h5>
                </div>
            </div>
        </div>
    </section>
);

export default SlipUp;